import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Index',
        component: () => import(/* webpackChunkName: "Index" */ '../views/Index.vue'),
    },

    {
        path: '/Productos',
        name: 'Productos',
        component: () => import(/* webpackChunkName: "Productos" */ '../views/Productos.vue'),
    },

    {
        path: '/Productos/Add',
        name: 'AddProductos',
        component: () => import(/* webpackChunkName: "AddProductos" */ '../views/Producto/AddProductos.vue'),
    },

    {
        path: '/Productos/Edit/:id',
        name: 'EditProductos',
        component: () => import(/* webpackChunkName: "AddProductos" */ '../views/Producto/EditProductos.vue'),
    },


    {
        path: '/Clientes',
        name: 'Cliente',
        component: () => import(/* webpackChunkName: "Cliente" */ '../views/Cliente/Cliente.vue'),
    },
    {
        path: '/Clientes/Add',
        name: 'AddClientes',
        component: () => import(/* webpackChunkName: "AddClientes" */ '../views/Cliente/AddClientes.vue'),
    },

    {
        path: '/Clientes/Edit/:id',
        name: 'EditClientes',
        component: () => import(/* webpackChunkName: "EditClientes" */ '../views/Cliente/EditClientes.vue'),
    },

    {
        path: '/Facturas',
        name: 'Factura',
        component: () => import(/* webpackChunkName: "Factura" */ '../views/Factura/Factura.vue'),
    },

    {
        path: '/Tableros',
        name: 'Dashboard',
        component: () => import(/* webpackChunkName: "Dashboard" */ '../views/Dashboard/Dashboard.vue'),
    },

    {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    }
]

const router = new VueRouter({
    routes
})

export default router
